import { render } from "./AssignUrlDialog.vue?vue&type=template&id=406ad33f&scoped=true"
import script from "./AssignUrlDialog.vue?vue&type=script&lang=js"
export * from "./AssignUrlDialog.vue?vue&type=script&lang=js"

import "./AssignUrlDialog.vue?vue&type=style&index=0&id=406ad33f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-406ad33f"]])

export default __exports__